import PaymentCallback from "@tw/purchase-cra/lib/components/payment/3ds-payment-callback/3ds-payment-callback-nextjs";
import PageWrapper from "../wrappers/page-wrapper";

PaymentCallback.domainName = "payment-callback";

export default PageWrapper(PaymentCallback);
